import React from "react";

// import Section1 from "../includes/ContactUs/Section1";
import Section2 from "../includes/ContactUs/Section2";
import Section1 from "../includes/ContactUsNew/Section1";

// form from homepage
import Section9 from "../includes/Home/Section9";

// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

const ContactUs = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "exddigital.com",
    },
    headline: "ExD Digital - Contact Us",
    image: "https://www.exddigital.com/images/contact-us/main-banner.jpg",
    author: {
      "@type": "Organization",
      name: "ExD Digital - Contact Us",
      url: "https://www.exddigital.com/contact-us",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.png",
      },
    },
    datePublished: "2023-08-06",
    dateModified: "2023-08-07",
  };

  return (
    <>
      <Helmet>
        <title>Contact Us</title>
        <link rel="canonical" href="https://www.exddigital.com/contact-us" />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="contact-main">
        <article className="contact-details">
          <Section1 url={devUrl} />
          {/* <Section2 url={devUrl} /> */}

          {/* <Section9 url={devUrl} /> */}
        </article>
      </main>
    </>
  );
};
export default React.memo(ContactUs);
